(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["edh-announce"] && !Shopify.designMode) return;
  try {
    
(() => {
  const build = (root) => {
    const track = root.querySelector('[data-edh-ann-track]');
    const seed  = root.querySelector('[data-edh-ann-set]');
    if (!track || !seed) return;
    track.querySelectorAll('[data-edh-ann-clone]').forEach(n => n.remove());
    const setW = seed.getBoundingClientRect().width;
    if (!setW) return;
    root.style.setProperty('--edh-ann-set', setW + 'px');
    const needed = Math.ceil(root.getBoundingClientRect().width / setW) + 1;
    for (let i = 0; i < needed; i++) {
      const c = seed.cloneNode(true);
      c.setAttribute('data-edh-ann-clone', '');
      c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('data-edh-ann-set');
      track.appendChild(c);
    }
  };
  const init = () => document.querySelectorAll('.edh-ann').forEach(build);
  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(init);
  addEventListener('resize', () => requestAnimationFrame(init));
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edh-audit"] && !Shopify.designMode) return;
  try {
    
(() => {
  const wire = (car) => {
    if (car.dataset.edhWired) return;
    car.dataset.edhWired = '1';
    const rail = car.querySelector('[data-edh-audit-rail]');
    const dots = car.querySelector('[data-edh-audit-dots]');
    const prev = car.querySelector('[data-edh-audit-prev]');
    const next = car.querySelector('[data-edh-audit-next]');
    if (!rail) return;
    const pages = [...rail.children];
    const step = () => rail.clientWidth + 12;

    if (dots && !dots.children.length) {
      pages.forEach((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Figures, page ' + (i + 1));
        b.addEventListener('click', () => rail.scrollTo({ left: i * step(), behavior: 'smooth' }));
        dots.appendChild(b);
      });
    }
    const sync = () => {
      const max = rail.scrollWidth - rail.clientWidth;
      const at = step() ? Math.round(rail.scrollLeft / step()) : 0;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max - 2;
      if (dots) [...dots.children].forEach((d, i) => d.classList.toggle('is-on', i === at));
    };
    prev?.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    next?.addEventListener('click', () => rail.scrollBy({ left:  step(), behavior: 'smooth' }));
    rail.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    if (window.ResizeObserver) new ResizeObserver(sync).observe(rail);
    sync();
  };
  const init = () => document.querySelectorAll('[data-edh-audit-car]').forEach(wire);
  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edh-cart-drawer"]) return;
  try {
    
(() => {
  if (window.__edhCart) return;

  const SEL = '[data-edh-cart]';
  const root = () => document.querySelector(SEL);
  let lastFocus = null;

  const busy = (on) => root()?.classList.toggle('is-busy', on);

  // Re-render this section server-side so money, discounts and totals stay
  // formatted by Liquid instead of being rebuilt (and rounded) in JS.
  const refresh = async () => {
    const el = root();
    if (!el) return;
    const id = el.dataset.edhSection;
    const wrap = el.closest('.shopify-section') || el.parentElement;
    // Always ask the root for the section. On /products/* and /cart the ?sections=
    // parameter is shadowed by Shopify's own product and cart JSON endpoints, which
    // return the resource instead of the section HTML. The drawer only reads `cart`,
    // so the page it is rendered against does not matter.
    const res = await fetch(`/?sections=${encodeURIComponent(id)}`, { headers: { Accept: 'application/json' } });
    if (!res.ok) return;
    const data = await res.json();
    const html = data[id];
    if (!html) return;
    const open = el.classList.contains('is-open');
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector(SEL);
    if (!next || !wrap) return;
    el.replaceWith(next);
    if (open) next.classList.add('is-open');
    syncCount();
  };

  // The header bubble lives outside this section, so it is updated by hand.
  const syncCount = async () => {
    const bubbles = document.querySelectorAll('[data-edh-cart-count]');
    if (!bubbles.length) return;
    const c = await fetch('/cart.js').then(r => r.json()).catch(() => null);
    if (!c) return;
    bubbles.forEach(b => {
      b.textContent = c.item_count;
      b.classList.toggle('is-empty', c.item_count === 0);
    });
  };

  const focusables = (el) =>
    [...el.querySelectorAll('a[href],button:not([disabled]),input,textarea,select,[tabindex]:not([tabindex="-1"])')]
      .filter(n => n.offsetParent !== null);

  const open = () => {
    const el = root();
    if (!el || el.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const first = focusables(el)[0];
    requestAnimationFrame(() => first && first.focus());
    const secs = parseInt(el.dataset.edhAutoclose || '0', 10);
    if (secs > 0) {
      clearTimeout(el.__t);
      el.__t = setTimeout(close, secs * 1000);
    }
  };

  const close = () => {
    const el = root();
    if (!el) return;
    clearTimeout(el.__t);
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
  };

  let toastT;
  const toast = (msg) => {
    const t = document.querySelector('[data-edh-cart-toast]');
    if (!t) return;
    t.querySelector('[data-edh-cart-toast-text]').textContent = msg;
    t.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(() => t.classList.remove('is-on'), 4000);
  };

  const post = async (url, body) => {
    busy(true);
    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Cart error');
      await refresh();
      await syncCount();
      return data;
    } finally {
      busy(false);
    }
  };

  // Add to cart from anywhere on the site, routed by the drawer's own setting.
  window.__edhCart = {
    open, close, refresh,
    behaviour: () => root()?.dataset.edhAtc || 'page',
    add: async (payload) => {
      const mode = window.__edhCart.behaviour();
      await post('/cart/add.js', payload);
      if (mode === 'drawer') open();
      else if (mode === 'stay') toast(root()?.dataset.edhToast || 'Added to cart');
      else if (mode === 'checkout') window.location.href = '/checkout';
    },
  };

  // ---- delegated events, so a re-rendered drawer stays wired ----
  document.addEventListener('click', (e) => {
    const el = root();

    if (e.target.closest('[data-edh-cart-open]')) { e.preventDefault(); open(); return; }

    const closer = e.target.closest('[data-edh-cart-close]');
    if (closer) {
      if (closer.hasAttribute('data-edh-cart-close') && closer.classList.contains('edh-cart__scrim')
          && el?.dataset.edhCloseOnScrim === 'false') return;
      e.preventDefault(); close(); return;
    }

    const step = e.target.closest('[data-edh-step]');
    if (step) {
      const input = step.parentElement.querySelector('[data-edh-qty]');
      const next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.edhStep, 10));
      post('/cart/change.js', { id: step.dataset.edhKey, quantity: next });
      return;
    }

    const rm = e.target.closest('[data-edh-remove]');
    if (rm) { post('/cart/change.js', { id: rm.dataset.edhKey, quantity: 0 }); return; }

    const addon = e.target.closest('[data-edh-addon]');
    if (addon) { post('/cart/add.js', { items: [{ id: Number(addon.dataset.edhAddon), quantity: 1 }] }); return; }

    // The code is applied by Shopify at checkout; nothing to validate here.
    if (e.target.closest('[data-edh-disc-apply]')) {
      const input = el?.querySelector('[data-edh-disc]');
      if (input && input.value.trim()) {
        window.location.href = `/checkout?discount=${encodeURIComponent(input.value.trim())}`;
      }
      return;
    }

    const go = e.target.closest('[data-edh-checkout]');
    if (go) {
      const input = el?.querySelector('[data-edh-disc]');
      const code = input && input.value.trim();
      if (code) { e.preventDefault(); window.location.href = `/checkout?discount=${encodeURIComponent(code)}`; }
    }
  });

  document.addEventListener('change', (e) => {
    const q = e.target.closest('[data-edh-qty]');
    if (!q) return;
    post('/cart/change.js', { id: q.dataset.edhKey, quantity: Math.max(0, parseInt(q.value, 10) || 0) });
  });

  let noteT;
  document.addEventListener('input', (e) => {
    const n = e.target.closest('[data-edh-note]');
    if (!n) return;
    clearTimeout(noteT);
    noteT = setTimeout(() => {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: n.value }),
      });
    }, 600);
  });

  document.addEventListener('keydown', (e) => {
    const el = root();
    // Enter inside the code field would otherwise submit the form and lose the code.
    if (e.key === 'Enter' && e.target.closest('[data-edh-disc]')) {
      e.preventDefault();
      const code = e.target.value.trim();
      if (code) window.location.href = `/checkout?discount=${encodeURIComponent(code)}`;
      return;
    }
    if (!el || !el.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    const f = focusables(el);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  document.addEventListener('shopify:section:load', syncCount);
  syncCount();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edh-community"] && !Shopify.designMode) return;
  try {
    
  class EdhCommunity {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('.edh-community__grid.is-row');
      if (!this.track) return;
      this.mode = root.dataset.scroll;
      this.prev = root.querySelector('[data-edh-prev]');
      this.next = root.querySelector('[data-edh-next]');
      if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
      if (this.next) this.next.addEventListener('click', () => this.step(1));
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      window.addEventListener('resize', () => this.sync());
      // The row can get measured before its layout settles - a theme-editor re-render,
      // a late font, a zero-width first paint - and the arrows would latch off for good.
      if (window.ResizeObserver) new ResizeObserver(() => this.sync()).observe(this.track);
      this.sync();
      if (this.mode === 'auto') this.startAuto();
    }
    // one card plus one gap — so a step always lands a card on the left edge
    amount() {
      const card = this.track.querySelector('.edh-community__card');
      if (!card) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    overflow() {
      return this.track.scrollWidth - this.track.clientWidth;
    }
    step(dir) {
      const max = this.overflow();
      if (max <= 1) return;
      let to = this.track.scrollLeft + dir * this.amount();
      if (to > max - 1) to = dir > 0 ? 0 : max;
      if (to < 0) to = max;
      this.track.scrollTo({ left: to });
    }
    sync() {
      if (!this.prev || !this.next) return;
      const off = this.overflow() <= 1;
      this.prev.disabled = off;
      this.next.disabled = off;
    }
    startAuto() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const every = (parseFloat(this.root.dataset.every) || 4) * 1000;
      let timer = null;
      const start = () => { if (!timer) timer = setInterval(() => this.step(1), every); };
      const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
      this.root.addEventListener('mouseenter', stop);
      this.root.addEventListener('mouseleave', start);
      this.root.addEventListener('focusin', stop);
      this.root.addEventListener('focusout', start);
      this.track.addEventListener('touchstart', stop, { passive: true });
      document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
      start();
    }
  }
  function edhCommunityInit() {
    document.querySelectorAll('.edh-community').forEach((el) => {
      if (el.dataset.edhReady) return;
      el.dataset.edhReady = 'true';
      new EdhCommunity(el);
    });
  }
  document.addEventListener('DOMContentLoaded', edhCommunityInit);
  document.addEventListener('shopify:section:load', edhCommunityInit);
  edhCommunityInit();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edh-ethos-cards"] && !Shopify.designMode) return;
  try {
    
  class EdhEthos {
    constructor(root) {
      this.root = root;
      this.single = root.dataset.single === 'true';
      this.cards = Array.from(root.querySelectorAll('.edh-ethos__card'));
      this.cards.forEach((card) => {
        const toggle = card.querySelector('.edh-ethos__toggle');
        if (!toggle) return;
        toggle.addEventListener('click', () => this.toggle(card, toggle));
      });
    }
    toggle(card, toggle) {
      const willOpen = !card.classList.contains('is-open');
      if (this.single && willOpen) {
        this.cards.forEach((other) => {
          if (other === card) return;
          other.classList.remove('is-open');
          const t = other.querySelector('.edh-ethos__toggle');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      }
      card.classList.toggle('is-open', willOpen);
      toggle.setAttribute('aria-expanded', String(willOpen));
    }
  }
  function edhEthosInit() {
    document.querySelectorAll('.edh-ethos').forEach((el) => {
      if (el.dataset.edhReady) return;
      el.dataset.edhReady = 'true';
      new EdhEthos(el);
    });
  }
  document.addEventListener('DOMContentLoaded', edhEthosInit);
  document.addEventListener('shopify:section:load', edhEthosInit);
  edhEthosInit();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edh-expect"] && !Shopify.designMode) return;
  try {
    
(() => {
  const wire = (card) => {
    if (card.dataset.edhWired) return;
    card.dataset.edhWired = '1';
    const tabs  = [...card.querySelectorAll('[data-edh-tab]')];
    const panes = [...card.querySelectorAll('[data-edh-pane]')];
    const nodes = [...card.querySelectorAll('[data-edh-node]')];
    const xlabs = [...card.querySelectorAll('[data-edh-xlab]')];
    const svg   = card.querySelector('[data-edh-svg]');
    const line  = card.querySelector('[data-edh-line]');
    const plot  = card.querySelector('[data-edh-plot]');
    const bub   = card.querySelector('[data-edh-bubble]');
    const bword = card.querySelector('[data-edh-bword]');
    const bnote = card.querySelector('[data-edh-bnote]');
    if (!tabs.length || !plot) return;

    let total = 0, cum = [];

    // The plot is drawn in REAL PIXELS, not in a stretched 0-100 viewBox. With
    // preserveAspectRatio="none" the path is scaled unevenly, so dash lengths no
    // longer match getTotalLength() and the reveal renders as broken segments.
    // Sizing the viewBox to the box removes the distortion entirely.
    const draw = () => {
      const w = plot.clientWidth, h = plot.clientHeight;
      if (!w || !h || !svg || !line) return;
      svg.setAttribute('viewBox', `0 0 ${w} ${h}`);
      const pts = nodes.map(n => [
        (parseFloat(n.dataset.x) / 100) * w,
        h - (parseFloat(n.dataset.y) / 100) * h
      ]);
      line.setAttribute('points', pts.map(p => p.join(',')).join(' '));
      cum = [0]; total = 0;
      for (let i = 1; i < pts.length; i++) {
        total += Math.hypot(pts[i][0] - pts[i-1][0], pts[i][1] - pts[i-1][1]);
        cum.push(total);
      }
      line.style.setProperty('--edh-exp-len', total || 1);
      xlabs.forEach((l, i) => { l.style.left = nodes[i].dataset.x + '%'; });
    };

    const place = (i) => {
      const nd = nodes[i]; if (!bub || !nd) return;
      const w = plot.clientWidth, h = plot.clientHeight;
      if (!w || !h) return;
      const bw = bub.offsetWidth, bh = bub.offsetHeight;
      // 14px measured from the node still let the circle clip the NEXT segment,
      // because the line climbs away from the point the callout is anchored to.
      const gapPx = parseFloat(getComputedStyle(card.querySelector('.edh-exp__chart'))
                        .getPropertyValue('--edh-exp-gap')) || 0;
      const gapPct = (gapPx / h) * 100;
      const bhPct  = (bh / h) * 100;
      const y = parseFloat(nd.dataset.y);
      let below = (nd.dataset.side || 'above') === 'below';

      // Honour the chosen side, but flip rather than run off the chart. A zero gap
      // means the callout is meant to sit ON the point (phones), so neither the
      // side nor the flip applies - the centring transform does the work.
      if (gapPx > 0) {
        if (below && y - gapPct - bhPct < 0) below = false;
        else if (!below && y + gapPct + bhPct > 100) below = true;
      }

      bub.classList.toggle('is-below', below);
      const by = below ? y - gapPct : y + gapPct;
      // 14px of the circle may sit over the chart's padding - shunting it fully
      // inside would pull it off the point it is labelling.
      const halfX = Math.max(0, (bw / 2 / w) * 100 - (14 / w) * 100);
      bub.style.setProperty('--bx', Math.min(Math.max(parseFloat(nd.dataset.x), halfX), 100 - halfX) + '%');
      bub.style.setProperty('--by', Math.min(Math.max(by, 0), 100) + '%');
    };

    const show = (i) => {
      tabs.forEach((t, k) => { t.classList.toggle('is-on', k === i);
        t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      panes.forEach((p, k) => { p.classList.toggle('is-on', k === i); p.hidden = k !== i;
        if (k === i) { p.style.animation = 'none'; void p.offsetWidth; p.style.animation = ''; } });
      nodes.forEach((nd, k) => { nd.classList.toggle('is-on', k === i); nd.classList.toggle('is-lit', k <= i); });
      xlabs.forEach((l, k) => l.classList.toggle('is-on', k === i));
      if (line && total) line.style.setProperty('--edh-exp-off', total - (cum[i] || 0));
      const word = tabs[i].dataset.word || '', note = tabs[i].dataset.note || '';
      if (bword) bword.textContent = word;
      if (bnote) bnote.textContent = note;
      if (bub) bub.classList.toggle('is-empty', !word && !note);
      place(i);
    };

    const current = () => { const k = tabs.findIndex(t => t.classList.contains('is-on')); return k < 0 ? 0 : k; };

    tabs.forEach((t, i) => {
      t.addEventListener('click', () => show(i));
      t.addEventListener('keydown', (e) => {
        const d = /Down|Right/.test(e.key) ? 1 : /Up|Left/.test(e.key) ? -1 : 0;
        if (!d) return; e.preventDefault();
        const nx = (i + d + tabs.length) % tabs.length; tabs[nx].focus(); show(nx);
      });
    });
    nodes.forEach((nd, i) => nd.addEventListener('click', () => { show(i); tabs[i].focus(); }));

    const start = Math.max(0, Math.min(parseInt(bub?.dataset.edhStart || '0', 10) || 0, tabs.length - 1));
    draw(); show(start);
    if (window.ResizeObserver) new ResizeObserver(() => { draw(); show(current()); }).observe(plot);
    addEventListener('resize', () => { draw(); show(current()); });
  };
  const init = () => document.querySelectorAll('[data-edh-exp]').forEach(wire);
  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edh-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const wire = () => {
    // The cart icon opens the drawer unless the drawer is set to send people to /cart.
    document.querySelectorAll('[data-edh-cart-link]').forEach(a => {
      if (a.dataset.edhWired) return;
      a.dataset.edhWired = '1';
      a.addEventListener('click', (e) => {
        const mode = window.__edhCart?.behaviour();
        if (!mode || mode === 'page') return;
        e.preventDefault();
        window.__edhCart.open();
      });
    });

    document.querySelectorAll('[data-edh-burger]').forEach(btn => {
      if (btn.dataset.edhWired) return;
      btn.dataset.edhWired = '1';
      btn.addEventListener('click', () => {
        const head = btn.closest('.edh-head');
        const open = head.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  };
  document.addEventListener('DOMContentLoaded', wire);
  if (document.readyState !== 'loading') wire();
  document.addEventListener('shopify:section:load', wire);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edh-ingredient-rows"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function build(row) {
      var track = row.querySelector('.edh-ing__track');
      var seed  = row.querySelector('[data-edh-set]');
      if (!track || !seed) return;
      track.querySelectorAll('[data-edh-clone]').forEach(function (n) { n.remove(); });
      var setW = seed.getBoundingClientRect().width;
      if (!setW) return;
      track.style.setProperty('--edh-set', setW + 'px');
      var needed = Math.ceil(row.getBoundingClientRect().width / setW) + 1;
      for (var i = track.children.length; i < needed; i++) {
        var c = seed.cloneNode(true);
        c.removeAttribute('data-edh-set');
        c.setAttribute('data-edh-clone', '');
        c.setAttribute('aria-hidden', 'true');
        track.appendChild(c);
      }
    }
    function init(root) {
      var rows = root.querySelectorAll('[data-edh-row]');
      rows.forEach(build);
      if (window.ResizeObserver) {
        var t;
        new ResizeObserver(function () {
          clearTimeout(t); t = setTimeout(function () { rows.forEach(build); }, 150);
        }).observe(root);
      }
      if (document.fonts && document.fonts.ready) { document.fonts.ready.then(function () { rows.forEach(build); }); }
      root.querySelectorAll('.edh-ing__thumb img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', function () { rows.forEach(build); }, { once: true });
      });
    }
    document.querySelectorAll('[data-edh-ing]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-edh-ing]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edh-marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function build(root) {
      var track = root.querySelector('.edh-marquee__track');
      var seed  = root.querySelector('[data-edh-set]');
      if (!track || !seed) return;
      track.querySelectorAll('[data-edh-clone]').forEach(function (n) { n.remove(); });
      var setW = seed.getBoundingClientRect().width;
      if (!setW) return;
      root.style.setProperty('--edh-set', setW + 'px');
      // one set must cover the viewport, plus one more to scroll into
      var needed = Math.ceil(root.getBoundingClientRect().width / setW) + 1;
      for (var i = track.children.length; i < needed; i++) {
        var c = seed.cloneNode(true);
        c.removeAttribute('data-edh-set');
        c.setAttribute('data-edh-clone', '');
        c.setAttribute('aria-hidden', 'true');
        track.appendChild(c);
      }
    }
    function init(root) {
      build(root);
      if (window.ResizeObserver) {
        var t;
        new ResizeObserver(function () { clearTimeout(t); t = setTimeout(function () { build(root); }, 150); }).observe(root);
      }
      if (document.fonts && document.fonts.ready) { document.fonts.ready.then(function () { build(root); }); }
    }
    document.querySelectorAll('[data-edh-marquee]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-edh-marquee]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edh-pdp-buy"] && !Shopify.designMode) return;
  try {
    
(() => {
  const wire = (root) => {
    if (root.dataset.edhWired) return;
    root.dataset.edhWired = '1';
    const idField  = root.querySelector('[data-edh-id]');
    const qtyField = root.querySelector('[data-edh-qty-field]');
    root.querySelectorAll('input[name="edh-plan"]').forEach(r => {
      r.addEventListener('change', () => {
        if (!r.checked) return;
        if (idField)  idField.value  = r.value;
        if (qtyField) qtyField.value = r.dataset.edhQty || 1;
      });
      if (r.checked) r.dispatchEvent(new Event('change'));
    });
  };

  // Thumbnail strip — swap the hero, keep the clicked thumb marked.
  const wireThumbs = (gal) => {
    const hero = gal.querySelector('[data-edh-hero-img]');
    const thumbs = gal.querySelectorAll('.edh-pdp__thumb');
    if (!hero || !thumbs.length) return;
    const list = [...thumbs];
    const show = (t) => {
      hero.src = t.dataset.src;
      if (t.dataset.srcset) hero.srcset = t.dataset.srcset;
      list.forEach(o => o.classList.toggle('is-on', o === t));
      t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    };
    list.forEach(t => t.addEventListener('click', () => show(t)));

    // Arrows flanking the thumb strip. They wrap, so neither end is a dead click.
    const step = (d) => {
      const at = list.findIndex(t => t.classList.contains('is-on'));
      show(list[((at < 0 ? 0 : at) + d + list.length) % list.length]);
    };
    const prev = gal.querySelector('[data-edh-hero-prev]');
    const next = gal.querySelector('[data-edh-hero-next]');
    // One shot means nothing to step to - hide the pair rather than leave it inert.
    if (list.length < 2) { prev?.remove(); next?.remove(); return; }
    gal.querySelector('.edh-pdp__thumbwrap')?.classList.add('has-nav');
    prev?.addEventListener('click', () => step(-1));
    next?.addEventListener('click', () => step(1));
  };

  // Carousel — arrows, dots, and the scroll position that drives both.
  const wireCarousel = (car) => {
    const rail = car.querySelector('[data-edh-rail]');
    const dots = car.querySelector('[data-edh-rail-dots]');
    const prev = car.querySelector('[data-edh-rail-prev]');
    const next = car.querySelector('[data-edh-rail-next]');
    if (!rail) return;
    const slides = [...rail.children];
    if (dots && !dots.children.length) {
      slides.forEach((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to image ' + (i + 1));
        b.addEventListener('click', () => rail.scrollTo({ left: slides[i].offsetLeft - rail.offsetLeft, behavior: 'smooth' }));
        dots.appendChild(b);
      });
    }
    const step = () => rail.clientWidth || 1;
    const sync = () => {
      const max = rail.scrollWidth - rail.clientWidth;
      const at = Math.round(rail.scrollLeft / step());
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max - 2;
      if (dots) [...dots.children].forEach((d, i) => d.classList.toggle('is-on', i === at));
    };
    prev?.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    next?.addEventListener('click', () => rail.scrollBy({ left:  step(), behavior: 'smooth' }));
    rail.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    // The rail can be measured before layout settles - a theme-editor re-render, a
    // late image - and the arrows would latch off for good. Watch instead of guessing.
    if (window.ResizeObserver) new ResizeObserver(sync).observe(rail);
    sync();
  };

  const wireGallery = (gal) => {
    if (gal.dataset.edhWired) return;
    gal.dataset.edhWired = '1';
    wireThumbs(gal);
    gal.querySelectorAll('[data-edh-carousel]').forEach(wireCarousel);
  };

  // Add to cart is handed to the drawer when one is present and set to something
  // other than the cart page; otherwise the form posts natively as it always did.
  const wireAtc = (form) => {
    if (form.dataset.edhAtcWired) return;
    form.dataset.edhAtcWired = '1';
    form.addEventListener('submit', async (e) => {
      const cart = window.__edhCart;
      // A per-product override beats the global cart setting: [01] must go straight
      // to checkout while [03] opens the drawer, and one shared setting cannot do both.
      const over = form.dataset.edhAtcMode;
      const mode = (over && over !== 'inherit') ? over : (cart ? cart.behaviour() : 'page');
      if (mode === 'page') return;

      // Straight-to-checkout is a plain form POST with Shopify's own return_to, not a
      // fetch plus a scripted redirect. A native submit survives the places that block
      // scripted navigation - the theme editor's preview among them - and it needs no
      // JS at all, so the button cannot end up doing nothing.
      if (mode === 'checkout') {
        if (!form.querySelector('input[name="return_to"]')) {
          const rt = document.createElement('input');
          rt.type = 'hidden'; rt.name = 'return_to'; rt.value = '/checkout';
          form.appendChild(rt);
        }
        // Safety net. A bundle app binds its own submit handler on this same form and
        // can preventDefault before ours runs - and when its own flow then stalls, the
        // native POST never fires and the button does NOTHING, which is what Bohdan hit.
        // If we are still on this page shortly after, finish the job ourselves: skip the
        // add if something already put the item in the cart, then go to checkout.
        const here = location.href;
        const idEl = form.querySelector('[data-edh-id]');
        const qtyEl = form.querySelector('[data-edh-qty-field]');
        let before = null;
        fetch('/cart.js').then(r => r.json()).then(c => { before = c.item_count; }).catch(() => {});
        setTimeout(async () => {
          if (location.href !== here) return;               // the native submit won
          try {
            const now = await fetch('/cart.js').then(r => r.json());
            if (before === null || now.item_count <= before) {
              await fetch('/cart/add.js', {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id: Number(idEl && idEl.value),
                  quantity: Number(qtyEl && qtyEl.value) || 1
                })
              });
            }
          } catch (ex) { /* fall through - checkout will show whatever is in the cart */ }
          window.location.href = '/checkout';
        }, 1600);
        return;
      }

      e.preventDefault();
      const btn = form.querySelector('[data-edh-atc-btn]');
      const label = form.querySelector('[data-edh-atc-label]');
      const err = form.parentElement.querySelector('[data-edh-atc-err]');
      const was = label?.textContent;
      if (err) { err.hidden = true; err.textContent = ''; }
      if (btn) btn.disabled = true;
      if (label) label.textContent = 'Adding…';
      try {
        await cart.add({
          id: Number(form.querySelector('[data-edh-id]').value),
          quantity: Number(form.querySelector('[data-edh-qty-field]').value) || 1,
        });
      } catch (ex) {
        if (err) { err.textContent = ex.message; err.hidden = false; }
      } finally {
        if (btn) btn.disabled = false;
        if (label && was) label.textContent = was;
      }
    });
  };

  const init = () => {
    document.querySelectorAll('.edh-pdp').forEach(wire);
    document.querySelectorAll('[data-edh-gallery]').forEach(wireGallery);
    document.querySelectorAll('.edh-pdp__form').forEach(wireAtc);
  };
  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edh-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {


  // ---- hand the click to Judge.me's own form ----
  const wireJudgeme = (sec) => {
    const btn = sec.querySelector('[data-edh-rev-jm]');
    if (!btn || btn.dataset.edhWired) return;
    btn.dataset.edhWired = '1';

    const findJmBtn = () => sec.querySelector('.edh-rev__collector .jm-button, .edh-rev__collector .jdgm-write-rev-link');
    // Judge.me builds its modal inside the widget, which we have hidden - so lift it
    // to <body> the first time, or it opens invisibly.
    const liftModal = () => {
      const m = document.querySelector('.edh-rev__collector .jdgm-write-review-modal');
      if (m && m.parentElement !== document.body) document.body.appendChild(m);
    };

    btn.addEventListener('click', () => {
      const jm = findJmBtn();
      if (jm) { jm.click(); setTimeout(liftModal, 30); return; }
      // Judge.me not up yet: wait briefly, then fall back rather than do nothing
      let tries = 0;
      const t = setInterval(() => {
        const j = findJmBtn();
        if (j) { clearInterval(t); j.click(); setTimeout(liftModal, 30); }
        else if (++tries > 20) {
          clearInterval(t);
          const own = sec.querySelector('[data-edh-rev-modal]');
          if (own) { own.hidden = false; document.body.style.overflow = 'hidden'; }
          else window.location.href = '/pages/contact';
        }
      }, 150);
    });
  };

  // ---- write-a-review modal ----
  const wireModal = (sec) => {
    const modal = sec.querySelector('[data-edh-rev-modal]');
    if (!modal || modal.dataset.edhWired) return;
    modal.dataset.edhWired = '1';
    const open  = () => { modal.hidden = false; document.body.style.overflow = 'hidden';
                          modal.querySelector('input,textarea,button')?.focus(); };
    const close = () => { modal.hidden = true; document.body.style.overflow = ''; };
    sec.querySelectorAll('[data-edh-rev-open]').forEach(b => b.addEventListener('click', open));
    modal.querySelectorAll('[data-edh-rev-close]').forEach(b => b.addEventListener('click', close));
    addEventListener('keydown', e => { if (e.key === 'Escape' && !modal.hidden) close(); });
    // Shopify bounces back to the page after a contact post, so reopen on the
    // thank-you rather than leaving the reader wondering if it sent.
    if (location.search.indexOf('contact_posted=true') > -1) open();
  };

  const wire = (sec) => {
    if (sec.dataset.edhWired) return;
    sec.dataset.edhWired = '1';
    const grid  = sec.querySelector('[data-edh-rev-grid]');
    const cards = [...sec.querySelectorAll('[data-edh-rev-card]')];
    const sort  = sec.querySelector('[data-edh-rev-sort]');
    const more  = sec.querySelector('[data-edh-rev-more]');
    const empty = sec.querySelector('[data-edh-rev-empty]');
    if (!grid || !cards.length) return;   // modal is wired separately, above

    const per = parseInt(getComputedStyle(grid).getPropertyValue('--edh-rev-page'), 10) || 6;
    let rating = 'all', topic = 'all', shown = per;

    const matches = (c) =>
      (rating === 'all' || c.dataset.stars === rating) &&
      (topic  === 'all' || (c.dataset.topics || '').split('|').includes(topic));

    const render = () => {
      // Read the live DOM order, not the authored array: reorder() moves the nodes,
      // and paging off the original order meant sorting by Lowest still showed the
      // first six as authored - the 3-star review stayed hidden on page one.
      const ordered = [...grid.children].filter(el => el.matches('[data-edh-rev-card]'));
      const hits = ordered.filter(matches);
      ordered.forEach(c => { c.hidden = true; });
      hits.slice(0, shown).forEach(c => { c.hidden = false; });
      if (empty) empty.hidden = hits.length > 0;
      if (more)  more.hidden  = hits.length <= shown;
    };

    const reorder = (mode) => {
      const key = {
        helpful: c => -(+c.dataset.helpful || 0),
        newest:  c => -(+c.dataset.date || 0),
        highest: c => -(+c.dataset.stars || 0),
        lowest:  c => (+c.dataset.stars || 0),
      }[mode] || (c => +c.dataset.i);
      // stable: fall back to the authored order so equal keys never shuffle
      [...cards].sort((a, b) => (key(a) - key(b)) || (+a.dataset.i - +b.dataset.i))
                .forEach(c => grid.appendChild(c));
    };

    sec.querySelectorAll('[data-edh-rating]').forEach(btn => {
      btn.addEventListener('click', () => {
        rating = btn.dataset.edhRating; shown = per;
        sec.querySelectorAll('[data-edh-rating]').forEach(o => o.classList.toggle('is-on', o === btn));
        render();
      });
    });
    sec.querySelectorAll('[data-edh-topic]').forEach(btn => {
      btn.addEventListener('click', () => {
        topic = btn.dataset.edhTopic; shown = per;
        sec.querySelectorAll('[data-edh-topic]').forEach(o => o.classList.toggle('is-on', o === btn));
        render();
      });
    });
    sort?.addEventListener('change', () => { reorder(sort.value); render(); });
    more?.addEventListener('click', () => { shown += per; render(); });

    reorder(sort ? sort.value : 'helpful');
    render();
  };
  const init = () => document.querySelectorAll('.edh-rev').forEach(sec => { wireModal(sec); wireJudgeme(sec); wire(sec); });
  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edh-routine"] && !Shopify.designMode) return;
  try {
    
(() => {
  const wire = (list) => {
    if (list.dataset.edhWired) return;
    list.dataset.edhWired = '1';
    const exclusive = list.hasAttribute('data-edh-exclusive');
    list.querySelectorAll('[data-edh-step]').forEach(btn => {
      btn.addEventListener('click', () => {
        const step = btn.closest('.edh-rout__step');
        const open = !step.classList.contains('is-open');
        if (exclusive && open) {
          list.querySelectorAll('.edh-rout__step.is-open').forEach(o => {
            o.classList.remove('is-open');
            o.querySelector('[data-edh-step]')?.setAttribute('aria-expanded', 'false');
          });
        }
        step.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        // Swap the shared photo to the step that just opened. Cross-fade rather than
        // cut, and preload so the fade never lands on a blank frame.
        //
        // The token is not optional: an uncached preload can resolve AFTER a later
        // click, and without it a quick run down the steps leaves the photo showing
        // whichever image happened to finish last rather than the open step.
        const card = list.closest('.edh-rout__card') || document;
        const img  = card.querySelector('[data-edh-rout-img]');
        const src  = step.dataset.edhImg;
        //
        // The token must be claimed on EVERY open, before any "is it already
        // showing?" test. Skipping the claim when the target happens to match the
        // displayed src leaves an earlier in-flight swap holding the newest token,
        // and it lands after this click — the photo then shows a step that is closed.
        if (open && img && src) {
          const token = (list._edhImgToken = (list._edhImgToken || 0) + 1);
          const apply = () => {
            if (token !== list._edhImgToken) return;      // a later click already won
            if (img.getAttribute('src') === src) return;  // nothing to change
            img.style.opacity = '0';
            setTimeout(() => {
              if (token !== list._edhImgToken) { img.style.opacity = ''; return; }
              img.setAttribute('src', src);
              if (step.dataset.edhSrcset) img.setAttribute('srcset', step.dataset.edhSrcset);
              img.style.opacity = '';
            }, 160);
          };
          const pre = new Image();
          pre.onload = apply;
          pre.onerror = apply;          // a broken file should still not freeze the swap
          pre.src = src;
          if (pre.complete) apply();    // already cached: fire now, onload may not
        }
      });
    });
  };
  const init = () => document.querySelectorAll('[data-edh-steps]').forEach(wire);
  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edh-ugc"] && !Shopify.designMode) return;
  try {
    
(() => {
  const buildStrip = (root) => {
    const track = root.querySelector('[data-edh-ugc-track]');
    const seed  = root.querySelector('[data-edh-ugc-set]');
    if (!track || !seed) return;
    track.querySelectorAll('[data-edh-ugc-clone]').forEach(n => n.remove());
    const w = seed.getBoundingClientRect().width;
    if (!w) return;
    root.style.setProperty('--edh-ugc-set', w + 'px');
    const needed = Math.ceil(root.getBoundingClientRect().width / w) + 1;
    for (let i = 0; i < needed; i++) {
      const c = seed.cloneNode(true);
      c.setAttribute('data-edh-ugc-clone', '');
      c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('data-edh-ugc-set');
      track.appendChild(c);
    }
  };

  const wireRail = (sec) => {
    const rail = sec.querySelector('[data-edh-rail]');
    if (!rail || rail.dataset.edhWired) return;
    rail.dataset.edhWired = '1';
    const cards = [...rail.children];
    const dots  = sec.querySelector('[data-edh-dots]');
    const prev  = sec.querySelector('[data-edh-prev]');
    const next  = sec.querySelector('[data-edh-next]');

    // One dot per page, not per card - three-up on desktop is one page.
    const perPage = () => {
      const c = cards[0];
      if (!c) return 1;
      return Math.max(1, Math.round(rail.clientWidth / (c.getBoundingClientRect().width + 20)));
    };
    const step = () => (cards[0] ? (cards[0].getBoundingClientRect().width + 20) * perPage() : rail.clientWidth);

    const buildDots = () => {
      if (!dots) return;
      const pages = Math.max(1, Math.ceil(cards.length / perPage()));
      if (dots.children.length === pages) return;
      dots.innerHTML = '';
      for (let i = 0; i < pages; i++) {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to page ' + (i + 1));
        b.addEventListener('click', () => rail.scrollTo({ left: i * step(), behavior: 'smooth' }));
        dots.appendChild(b);
      }
    };

    const sync = () => {
      buildDots();
      const max = rail.scrollWidth - rail.clientWidth;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max - 2;
      if (dots) {
        const at = step() ? Math.round(rail.scrollLeft / step()) : 0;
        [...dots.children].forEach((d, i) => d.classList.toggle('is-on', i === at));
        dots.classList.toggle('is-hidden', dots.children.length < 2);
      }
    };

    prev?.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    next?.addEventListener('click', () => rail.scrollBy({ left:  step(), behavior: 'smooth' }));
    rail.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    // The rail can be measured before layout settles - a theme-editor re-render, a
    // late stylesheet, a zero-width first paint - and the dot count would latch wrong.
    // Watch the card too: its width is what decides how many fit on a page.
    if (window.ResizeObserver) {
      const ro = new ResizeObserver(sync);
      ro.observe(rail);
      if (cards[0]) ro.observe(cards[0]);
    }
    addEventListener('load', sync, { once: true });
    sync();

    // Auto-advance. Pauses on hover, on focus inside the rail, while the tab is
    // hidden, and while the reader is dragging - then wraps back to the start.
    const every = parseFloat(rail.dataset.edhAuto || '0');
    if (every > 0 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let timer = null, held = false;
      const tick = () => {
        if (held || document.hidden) return;
        const max = rail.scrollWidth - rail.clientWidth;
        if (rail.scrollLeft >= max - 2) rail.scrollTo({ left: 0, behavior: 'smooth' });
        else rail.scrollBy({ left: step(), behavior: 'smooth' });
      };
      const start = () => { stop(); timer = setInterval(tick, every * 1000); };
      const stop  = () => { if (timer) clearInterval(timer); timer = null; };
      const hold  = (v) => { held = v; };
      rail.addEventListener('pointerenter', () => hold(true));
      rail.addEventListener('pointerleave', () => hold(false));
      rail.addEventListener('focusin',  () => hold(true));
      rail.addEventListener('focusout', () => hold(false));
      rail.addEventListener('pointerdown', () => hold(true));
      addEventListener('pointerup', () => hold(false));
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
      start();
    }
  };

  const init = () => {
    document.querySelectorAll('[data-edh-ugc]').forEach(buildStrip);
    document.querySelectorAll('.edh-ugc').forEach(wireRail);
  };
  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();
  addEventListener('resize', () => requestAnimationFrame(init));
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
